import React, { Component } from 'react';

export default class Nav extends Component {
  render() {
    return <nav class="navbar navbar-expand-lg fixed-top sticky" id="navbar">
      <div class="container custom-container">
        <a class="navbar-brand logo f-30 text-dark fw-bold" href="/">
          <img src="images/logo-dark.png" class="logo-dark" alt="" height="40" />
          <img src="images/logo-light.png" class="logo-light" alt="" height="40" />
        </a>
        <div>
          <button class="navbar-toggler me-3" type="button" data-bs-toggle="collapse"
            data-bs-target="#navbarCollapse" aria-controls="navbarCollapse" aria-label="Toggle navigation">
            <i class="fa fa-bars"></i>
          </button>
        </div>
        <div class="collapse navbar-collapse" id="navbarCollapse" style={{
          // flexGrow: 0
        }}>

          {/* <ul class="navbar-nav mx-auto navbar-right">

            <li class="nav-item dropdown dropdown-hover">
              <a class="nav-link" href="/#home" id="homedrop" role="button"
                data-bs-toggle="">
                Home
              </a>
            </li>

            <li class="nav-item">
              <a href="/about" class="nav-link">Nots</a>
            </li>

            <li class="nav-item">
              <a href="/validator" class="nav-link">Validator</a>
            </li>

            <li class="nav-item">
              <a href="/#nsa" class="nav-link">NSA</a>
            </li>

           
            <li class="nav-item">
              <a href="https://notsnfts.medium.com/" class="nav-link">Blog</a>
            </li>
            <li class="nav-item">
              <a href="/rarity" class="nav-link">Rarity Calculator</a>
            </li>

          </ul> */}

        </div>

      </div>

    </nav>;
  }
}
